import {Segment} from 'semantic-ui-react';
import Fetcher from '../shared/fetches/fetcher';
import StudentCourseMenu from '../shared/student_course_menu';
import Voices from './voices';
import {fetchVoices} from '../../redux/actions/voice';

function VoicesContainer() {
  return (<StudentCourseMenu render={renderContent}/>);
}

function renderContent(studentCourse) {
  return (
    <Fetcher
      action={fetchVoices.bind(null, studentCourse.id)}
      stateSelector={state => state.voices}
      renderEmpty={renderNotFound}
      renderError={renderNotFound}
    >
      {voices => <Voices voices={voices}/>}
    </Fetcher>
  );
}

function renderNotFound() {
  return (
    <Segment textAlign='center'>
      <p>توضیح صوتی‌ای برای این دوره آموزشی یافت نشد.</p>
    </Segment>
  );
}

export default VoicesContainer;
